import Select from '../../../components/Select/Select';
import Datepicker from '../../../components/Inputs/Datepicker/Datepicker';
import SelectComplectations from '../../../components/Selects/SelectComplectations';
import SelectCarTransmissions from '../../../components/Selects/SelectCarTransmissions';
import SelectWd from '../../../components/Selects/SelectWd';
import SelectColor from '../../../components/Selects/SelectColor';
import SelectCity from '../../../components/Selects/SelectCity';
import SelectDc from '../../../components/Selects/SelectDc';
import SelectMarks from '../../../components/Selects/SelectMarks';
import SelectModels from '../../../components/Selects/SelectModels';
import { PURCHASE_PROCESS_TYPES } from '../../../constants/carOrigin';

export const ENGINE_TYPE_OPTIONS = [
  { value: 'PETROL', label: 'ÐÐµÐ½Ð·Ð¸Ð½' },
  { value: 'DIESEL', label: 'ÐÐ¸Ð·ÐµÐ»Ñ' },
  { value: 'GAS_PETROL', label: 'ÐÐ°Ð·-Ð±ÐµÐ½Ð·Ð¸Ð½' },
  { value: 'GAS', label: 'ÐÐ°Ð·' },
  { value: 'HYBRID', label: 'ÐÐ¸Ð±ÑÐ¸Ð´' },
  { value: 'ELECTRIC', label: 'Ð­Ð»ÐµÐºÑÑÐ¸ÑÐµÑÑÐ²Ð¾' },
];

/**
 * ÐÐ¾Ð»Ñ ÑÐ°ÑÐ°ÐºÑÐµÑÐ¸ÑÑÐ¸Ðº Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ â Ð±ÐµÐ· Ð¿Ð¾Ð»Ñ Â«ÐÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸ÐµÂ», ÐµÐ³Ð¾ ÐºÐ°Ð¶Ð´ÑÐ¹ ÑÐºÑÐ°Ð½
 * Ð´Ð¾Ð±Ð°Ð²Ð»ÑÐµÑ ÑÐ°Ð¼ (Ð¸Ð»Ð¸ Ð½Ðµ Ð´Ð¾Ð±Ð°Ð²Ð»ÑÐµÑ, ÐµÑÐ»Ð¸ ÑÐ¸Ð¿ Ð·Ð°ÑÐ¸ÐºÑÐ¸ÑÐ¾Ð²Ð°Ð½).
 *
 * @param {Object} carData â ÑÐµÐºÑÑÐ¸Ðµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ñ Ð´Ð»Ñ defaultValue
 * @param {Function} onMarkChange â Ð²ÑÐ·ÑÐ²Ð°ÐµÑÑÑ Ð¿ÑÐ¸ ÑÐ¼ÐµÐ½Ðµ Ð¼Ð°ÑÐºÐ¸
 * @param {Function} onModelChange â (modelOption, markOption) Ð¿ÑÐ¸ ÑÐ¼ÐµÐ½Ðµ Ð¼Ð¾Ð´ÐµÐ»Ð¸
 * @param {Function} getContainerId â ÐºÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑ Ð´Ð»Ñ Ð¿Ð¾Ð´Ð³ÑÑÐ·ÐºÐ¸ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¹
 * @param {Function} onDcChange â Ð²ÑÐ·ÑÐ²Ð°ÐµÑÑÑ Ð¿ÑÐ¸ ÑÐ¼ÐµÐ½Ðµ Ð´Ð¸Ð»ÐµÑÑÐºÐ¾Ð³Ð¾ ÑÐµÐ½ÑÑÐ°
 * @param {boolean} singleDc â Ð¾Ð´Ð¸Ð½ ÐÐ¦ Ð²Ð¼ÐµÑÑÐ¾ Ð¼ÑÐ»ÑÑÐ¸ÑÐµÐ»ÐµÐºÑÐ°
 * @param {boolean} usedDcOnly â Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÑÑ ÑÐ¾Ð»ÑÐºÐ¾ ÐÐ¡Ð (ÑÐ¾ÑÐºÐ¸ Ð¿ÑÐ¾Ð´Ð°Ð¶ ÐÐ£-Ð°Ð²ÑÐ¾)
 * @param {boolean} withTechPassport â Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÑ Ð½Ð¾Ð¼ÐµÑ Ð¸ Ð´Ð°ÑÑ ÑÐµÑÐ¿Ð°ÑÐ¿Ð¾ÑÑÐ° (Ð´Ð¾Ð³Ð¾Ð²Ð¾Ñ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ)
 * @param {boolean} mileageRequired â Ð¿ÑÐ¾Ð±ÐµÐ³ Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÐµÐ½ Ð²ÑÐµÐ³Ð´Ð° (Ð¸Ð½Ð°ÑÐµ â ÑÐ¾Ð»ÑÐºÐ¾ Ð´Ð»Ñ Ð±/Ñ Ð¿Ð¾ origin)
 * @param {boolean} usedDictionaries â Ð±/Ñ-Ð¿ÑÐ¾ÑÐµÑÑ: Ð² Ð¼Ð°ÑÐºÐ°Ñ/Ð¼Ð¾Ð´ÐµÐ»ÑÑ/ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸ÑÑ
 *   Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ Ð¸ Ð·Ð°Ð²ÐµÐ´ÑÐ½Ð½ÑÐµ Ð¿Ð¾Ð´ Ð±/Ñ, Ð¸ ÑÐ°Ð·ÑÐµÑÐ°ÐµÐ¼ Ð·Ð°Ð²ÐµÑÑÐ¸ Ð½Ð¾Ð²ÑÐµ Ð¿ÑÑÐ¼Ð¾ Ð² ÑÐµÐ»ÐµÐºÑÐµ.
 *   ÐÐ³ÑÐ°Ð½Ð¸ÑÐµÐ½Ð¸Ðµ Ð¿Ð¾ Ð¼Ð°ÑÐºÐ°Ð¼ ÐÐ¦ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÐ° Ð¿ÑÐ¸ ÑÑÐ¾Ð¼ ÑÐ½Ð¸Ð¼Ð°ÐµÐ¼: Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ
 *   Ð¿ÑÐ¸Ð½Ð¸Ð¼Ð°ÑÑ Ð¼Ð°ÑÐ¸Ð½Ñ Ð»ÑÐ±Ð¾Ð¹ Ð¼Ð°ÑÐºÐ¸, Ð° Ð½Ðµ ÑÐ¾Ð»ÑÐºÐ¾ ÑÐ¾Ð¹, ÐºÐ¾ÑÐ¾ÑÐ¾Ð¹ ÑÐ¾ÑÐ³ÑÐµÑ ÐÐ¦.
 */
export const buildCarInfoInputs = ({
  carData = {},
  onMarkChange,
  onModelChange,
  onDcChange,
  getContainerId,
  singleDc = false,
  usedDcOnly = false,
  withTechPassport = false,
  mileageRequired = false,
  usedDictionaries = false,
}) => [
  {
    name: 'mark',
    component: SelectMarks,
    byUser: !usedDictionaries,
    used: usedDictionaries,
    label: 'ÐÐ°ÑÐºÐ°',
    placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
    rules: { required: true },
    defaultValue: carData?.mark,
    onChangeCustom: () => onMarkChange && onMarkChange(),
  },
  {
    name: 'model',
    component: SelectModels,
    used: usedDictionaries,
    dependency: 'mark',
    dependencyAccessor: (obj) => obj?.value,
    label: 'ÐÐ¾Ð´ÐµÐ»Ñ',
    placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
    rules: { required: true },
    defaultValue: carData?.model,
    onChangeCustom: (modelOption, markOption) => onModelChange && onModelChange(modelOption, markOption),
  },
  {
    type: 'selectComplectations',
    name: 'complectationId',
    component: SelectComplectations,
    used: usedDictionaries,
    dependency: ['mark', 'model'],
    dependencyAccessor: (arr) => arr?.map((o) => o?.value).join('|'),
    params: () => (getContainerId ? getContainerId() : null),
    defaultValue: carData?.complectationId,
    rules: { required: true },
  },
  {
    type: 'input',
    name: 'issueYear',
    value: undefined,
    label: 'ÐÐ¾Ð´ Ð²ÑÐ¿ÑÑÐºÐ°',
    placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð³Ð¾Ð´ Ð²ÑÐ¿ÑÑÐºÐ°',
    inputType: 'number',
    rules: { required: true },
    defaultValue: carData?.issueYear,
  },
  {
    type: 'input',
    name: 'vin',
    value: undefined,
    label: 'VIN',
    placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ VIN',
    maxLength: 17,
    rules: { required: true },
    defaultValue: carData?.vin,
  },
  ...(withTechPassport
    ? [
        {
          // texNumber â ÑÐ¾ Ð¶Ðµ Ð¿Ð¾Ð»Ðµ Â«Ð¢ÐµÑÐ¿Ð°ÑÐ¿Ð¾ÑÑÂ», ÑÑÐ¾ Ð±Ð°Ð½ÐºÐ¸ ÑÐ¶Ðµ ÑÑÐµÐ±ÑÑÑ Ð² ÑÐ´ÐµÐ»ÐºÐµ,
          // Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð¿Ð¸ÑÐµÐ¼ Ð² Ð½ÐµÐ³Ð¾, Ð° Ð½Ðµ Ð·Ð°Ð²Ð¾Ð´Ð¸Ð¼ Ð²ÑÐ¾ÑÐ¾Ðµ.
          type: 'input',
          name: 'texNumber',
          label: 'ÐÐ¾Ð¼ÐµÑ ÑÐµÑÐ¿Ð°ÑÐ¿Ð¾ÑÑÐ°',
          placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð½Ð¾Ð¼ÐµÑ',
          rules: { required: true },
          defaultValue: carData?.texNumber,
        },
        {
          name: 'texDate',
          component: Datepicker,
          label: 'ÐÐ°ÑÐ° Ð²ÑÐ´Ð°ÑÐ¸ ÑÐµÑÐ¿Ð°ÑÐ¿Ð¾ÑÑÐ°',
          placeholder: 'Ð´Ð´-Ð¼Ð¼-Ð³Ð³Ð³Ð³',
          rules: { required: true },
          defaultValue: carData?.texDate,
        },
      ]
    : []),
  {
    type: 'selectColor',
    name: 'color',
    component: SelectColor,
    value: undefined,
    label: 'Ð¦Ð²ÐµÑ ÐºÑÐ·Ð¾Ð²Ð°',
    placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ ÑÐ²ÐµÑ',
    defaultValue: carData?.color,
    rules: { required: true },
  },
  {
    type: 'input',
    name: 'price',
    value: undefined,
    label: 'Ð¦ÐµÐ½Ð°',
    placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ ÑÐµÐ½Ñ',
    format: 'number',
    rules: { required: true },
    defaultValue: carData?.price,
  },
  {
    type: 'input',
    name: 'engine_volume',
    value: undefined,
    label: 'ÐÐ±ÑÐµÐ¼ Ð´Ð²Ð¸Ð³Ð°ÑÐµÐ»Ñ',
    placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð¾Ð±ÑÐµÐ¼ Ð´Ð²Ð¸Ð³Ð°ÑÐµÐ»Ñ',
    defaultValue: carData?.engine_volume,
  },
  {
    type: 'input',
    name: 'power',
    value: undefined,
    label: 'ÐÐ¾ÑÐ½Ð¾ÑÑÑ',
    placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð¼Ð¾ÑÐ½Ð¾ÑÑÑ',
    defaultValue: carData?.power,
  },
  {
    type: 'selectTransmissions',
    name: 'transmissionId',
    component: SelectCarTransmissions,
    value: undefined,
    label: 'Ð¢Ð¸Ð¿ ÐºÐ¾ÑÐ¾Ð±ÐºÐ¸ Ð¿ÐµÑÐµÐ´Ð°Ñ',
    placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ ÑÐ¸Ð¿',
    defaultValue: carData?.transmissionId,
    rules: { required: true },
  },
  {
    type: 'selectWd',
    name: 'wdId',
    component: SelectWd,
    value: undefined,
    label: 'Ð¢Ð¸Ð¿ Ð¿ÑÐ¸Ð²Ð¾Ð´Ð°',
    placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ ÑÐ¸Ð¿',
    defaultValue: carData?.wdId,
    rules: { required: true },
  },
  {
    type: 'selectCity',
    name: 'cityId',
    component: SelectCity,
    value: undefined,
    label: 'ÐÐ¾ÑÐ¾Ð´',
    defaultValue: carData?.cityId,
    rules: { required: true },
  },
  {
    name: 'dc',
    component: SelectDc,
    label: 'ÐÐ¸Ð»ÐµÑÑÐºÐ¸Ð¹ ÑÐµÐ½ÑÑ',
    placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
    defaultValue: carData?.dc,
    isMulti: !singleDc,
    used: usedDcOnly || undefined,
    onChangeCustom: (value) => onDcChange && onDcChange(value),
  },
  {
    type: 'input',
    name: 'mileage',
    value: undefined,
    label: 'ÐÑÐ¾Ð±ÐµÐ³, ÐºÐ¼',
    placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð¿ÑÐ¾Ð±ÐµÐ³',
    inputType: 'number',
    defaultValue: carData?.mileage,
    rules: mileageRequired
      ? { required: true }
      : {
          validate: (value, getValues) => {
            const origin = getValues('origin');
            const originValue = origin?.value;
            const isUsed =
              typeof originValue === 'string' && originValue.startsWith('factory_')
                ? origin?.isUsedFactory
                : PURCHASE_PROCESS_TYPES.includes(originValue);
            if (isUsed && (!value || value.toString().trim() === '')) {
              return 'ÐÑÐ¾Ð±ÐµÐ³ Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÐµÐ½ Ð´Ð»Ñ Ð±/Ñ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»ÐµÐ¹';
            }
            return true;
          },
        },
  },
  {
    type: 'select',
    name: 'engineType',
    component: Select,
    value: undefined,
    label: 'Ð¢Ð¸Ð¿ Ð´Ð²Ð¸Ð³Ð°ÑÐµÐ»Ñ',
    placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
    options: ENGINE_TYPE_OPTIONS,
    defaultValue: carData?.engineType,
    rules: { required: true },
  },
];

export default buildCarInfoInputs;
